import { render, staticRenderFns } from "./about.vue?vue&type=template&id=9c8a2062&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&id=9c8a2062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8a2062",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribeWebinar: require('/opt/render/project/src/channels2022/src/components/subscribe/SubscribeWebinar.vue').default})
